import { FeatureFlagClient, FeatureFlagApiClient, type FeatureFlagResponse } from "@skillr/common";

class FeatureFlags {
	private client: FeatureFlagClient;

	constructor(url: string) {
		this.client = new FeatureFlagClient(new FeatureFlagApiClient(), url);
	}

	async getFeatureFlags(options?: { overrides?: FeatureFlagResponse[] }): Promise<FeatureFlagResponse[]> {
		return this.client.getFeatureFlags(options);
	}

	async isFeatureFlagEnabled(featureId: string): Promise<boolean> {
		return this.client.isFeatureFlagEnabled(featureId);
	}

	async getFeatureFlag(featureId: string): Promise<FeatureFlagResponse | null> {
		return this.client.getFeatureFlag(featureId);
	}
}

export { FeatureFlags };
